(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initTapnFooter(root = document) {
    const footer = root.matches?.('[data-tapn-footer]') ? root : root.querySelector?.('[data-tapn-footer]');
    if (!footer || footer.dataset.tapnFooterBound === 'true') return;

    footer.dataset.tapnFooterBound = 'true';
    footer.classList.add('tapn-footer--motion-ready');

    const desktopFooter = window.matchMedia('(min-width: 40rem)');
    const columns = [...footer.querySelectorAll('[data-tapn-footer-column]')];
    const summaries = columns.map((column) => column.querySelector('summary')).filter(Boolean);
    summaries.forEach((summary) => {
      summary.addEventListener('click', (event) => {
        if (desktopFooter.matches) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
    const syncColumns = () => {
      columns.forEach((column) => {
        if (desktopFooter.matches) column.open = true;
        else column.removeAttribute('open');
      });
      summaries.forEach((summary) => {
        summary.tabIndex = desktopFooter.matches ? -1 : 0;
        summary.setAttribute('aria-disabled', desktopFooter.matches ? 'true' : 'false');
      });
    };
    syncColumns();
    desktopFooter.addEventListener?.('change', syncColumns);

    const reveals = [...footer.querySelectorAll('.tapn-footer__reveal')];
    const show = (element, fallbackIndex = 0) => {
      const delay = Number(element.dataset.delay ?? Math.min(fallbackIndex, 6) * 130);
      element.style.transitionDelay = `${delay}ms`;
      element.classList.add('is-visible');
    };

    if (reducedMotion.matches || typeof IntersectionObserver === 'undefined') {
      reveals.forEach(show);
      return;
    }

    requestAnimationFrame(() => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const observer = new IntersectionObserver((entries) => {
        entries.filter((entry) => entry.isIntersecting).forEach((entry, index) => {
          show(entry.target, index);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      reveals.forEach((element, index) => {
        if (element.getBoundingClientRect().top < viewportHeight * 0.92) show(element, index);
        else observer.observe(element);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initTapnFooter());
  else initTapnFooter();

  document.addEventListener('shopify:section:load', (event) => initTapnFooter(event.target));
})();
